import { Banknote, Gift, HelpCircle } from 'lucide-react';
import type { OtherInstruction } from '@/lib/services/redemption';

export const OTHER_INSTRUCTION_LABELS: Record<OtherInstruction, string> = {
  'collect-in-trust': 'Collect in Trust',
  'transfer-to-beneficiary': 'Transfer to Beneficiary',
  undecided: 'Undecided'
};

export const OTHER_INSTRUCTION_ICONS: Record<
  OtherInstruction,
  typeof Banknote
> = {
  'collect-in-trust': Banknote,
  'transfer-to-beneficiary': Gift,
  undecided: HelpCircle
};

export const OTHER_INSTRUCTION_DESCRIPTIONS: Record<OtherInstruction, string> =
  {
    'collect-in-trust':
      'Take possession and deposit into the estate trust account. Use this for cash on hand or items that will be sold to realise cash.',
    'transfer-to-beneficiary':
      'Transfer the item in-specie to a named beneficiary (no cash enters the estate).',
    undecided: 'Decision pending. The item stays in Set Instructions.'
  };

export const OTHER_RESOLVED_LABELS: Record<OtherInstruction, string> = {
  'collect-in-trust': 'Collected',
  'transfer-to-beneficiary': 'Transferred',
  undecided: 'Resolved'
};

export const OTHER_INSTRUCTION_OPTIONS: OtherInstruction[] = [
  'collect-in-trust',
  'transfer-to-beneficiary',
  'undecided'
];
